// Mash Factors — the question/criterion the player answers on every matchup.
// The list is extensible; new factors slot in without gameplay changes.
// A future "custom" entry can be added (id: "custom") + a free-text label — the
// data model already stores a label alongside the id to support that.

export const MASH_FACTORS = [
  { id: "unforgettable_evening", label: "Who would you rather spend an unforgettable evening with?" },
  { id: "bde", label: "Who has more BDE?" },
  { id: "date", label: "Who Would You Rather Date?" },
  { id: "more_talented", label: "Who Is More Talented?" },
  { id: "less_talented", label: "Who Is Less Talented?" },
  { id: "more_attractive", label: "Who Is More Attractive?" },
  { id: "party", label: "Who Would You Rather Party With?" },
  { id: "stranded", label: "Who Would You Rather Be Stranded With?" },
  { id: "fight", label: "Who Would Win in a Fight?" },
  { id: "goat", label: "Who Is the G.O.A.T.?" },
  { id: "dinner", label: "Who Would You Rather Have Dinner With?" },
  { id: "better_at", label: "Who Is Better at What They Do?" },
  { id: "cringe", label: "Who Is More Cringe?" },
  { id: "funnier", label: "Who Is Funnier?" },
  { id: "smarter", label: "Who Is Smarter?" },
  { id: "cooler", label: "Who Is Cooler?" },
  { id: "legacy", label: "Who Has the Greater Legacy?" },
  { id: "be_for_day", label: "Who Would You Rather Be for a Day?" },
  { id: "family", label: "Who Would You Rather Bring Home to Meet Your Family?" },
];

export const DEFAULT_MASH_FACTOR_ID = "unforgettable_evening";

export const getMashFactor = (id) =>
  MASH_FACTORS.find((f) => f.id === id) || MASH_FACTORS.find((f) => f.id === DEFAULT_MASH_FACTOR_ID);

// Deterministic per-day Mash Factor so every player sees the same one on the same date.
export const todaysMashFactor = (dateString) => {
  const d = dateString || new Date().toISOString().slice(0, 10); // YYYY-MM-DD
  let hash = 0;
  for (let i = 0; i < d.length; i++) {
    hash = (hash * 31 + d.charCodeAt(i)) >>> 0;
  }
  return MASH_FACTORS[hash % MASH_FACTORS.length];
};

// Helper: given an id AND an optional custom label, produce a display label.
// Supports future custom-factor use case without changing the storage shape.
export const mashFactorDisplay = (id, customLabel) => {
  if (id === "custom" && customLabel) return customLabel;
  return getMashFactor(id).label;
};
